"use strict";Object.defineProperty(exports, "__esModule", {value: true});


 const isOrgV1 = (o) => 'EnabledFeatures' in o; exports.isOrgV1 = isOrgV1
 const isOrgV2 = (o) => !exports.isOrgV1.call(void 0, o); exports.isOrgV2 = isOrgV2

 const isUserV1 = (u) => !exports.isUserV2.call(void 0, u); exports.isUserV1 = isUserV1
 const isUserV2 = (u) => 'Teams' in u; exports.isUserV2 = isUserV2
